var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkloadBreakdown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 130,
    viewBox: "0 0 206 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.5 160.5H0.5V6C0.5 2.96243 2.96244 0.5 6 0.5H200C203.038 0.5 205.5 2.96244 205.5 6V160.5Z",
    fill: "#F3F3F3",
    stroke: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.77 44C66.0992 44 71.3528 45.2613 76.1012 47.6807C80.8496 50.1001 84.958 53.609 88.0904 57.9205C91.2229 62.2319 93.2905 67.2235 94.1242 72.4872C94.9578 77.7508 94.5339 83.137 92.8871 88.2055L60.77 77.77L60.77 44Z",
    fill: "#9E9E9E",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7044 88.7518C90.4079 95.4301 86.0754 101.22 80.3165 105.308C74.5577 109.396 67.6622 111.575 60.6002 111.54L60.77 77.77L92.7044 88.7518Z",
    fill: "#9E9E9E",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0805 111.533C54.3935 111.417 48.828 109.866 43.9004 107.025L60.77 77.77L60.0805 111.533Z",
    fill: "#9E9E9E",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3913 106.725C38.5141 103.798 34.4554 99.6859 31.5917 94.7712L60.77 77.77L43.3913 106.725Z",
    fill: "#9E9E9E",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3268 94.3082C28.5675 89.3957 27.0812 83.871 27.0032 78.2372C26.9253 72.6034 28.2582 67.0396 30.8805 62.0527L60.77 77.77L31.3268 94.3082Z",
    fill: "#9E9E9E",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5857 52.3089C44.6008 47.0679 52.2772 44.1258 60.2543 44.0039L60.77 77.77L38.5857 52.3089Z",
    fill: "#9E9E9E",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1393 61.5702C32.9602 58.2396 35.3296 55.2398 38.148 52.697L60.77 77.77L31.1393 61.5702Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 78,
    r: 28,
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.23 44C149.559 44 154.813 45.2613 159.561 47.6807C164.31 50.1001 168.418 53.609 171.551 57.9205C174.683 62.2319 176.751 67.2235 177.584 72.4872C178.418 77.7508 177.994 83.137 176.347 88.2055L144.23 77.77L144.23 44Z",
    fill: "#9E9E9E",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.165 88.7518C173.868 95.4301 169.535 101.22 163.777 105.308C158.018 109.396 151.122 111.575 144.06 111.54L144.23 77.77L176.165 88.7518Z",
    fill: "#9E9E9E",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.541 111.533C137.854 111.417 132.288 109.866 127.36 107.025L144.23 77.77L143.541 111.533Z",
    fill: "#9E9E9E",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.851 106.725C121.974 103.798 117.915 99.6859 115.052 94.7712L144.23 77.77L126.851 106.725Z",
    fill: "#9E9E9E",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.787 94.3082C112.028 89.3957 110.541 83.871 110.463 78.2372C110.385 72.6034 111.718 67.0396 114.341 62.0527L144.23 77.77L114.787 94.3082Z",
    fill: "#9E9E9E",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.046 52.3089C128.061 47.0679 135.737 44.1258 143.714 44.0039L144.23 77.77L122.046 52.3089Z",
    fill: "#9E9E9E",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.599 61.5702C116.42 58.2396 118.79 55.2398 121.608 52.697L144.23 77.77L114.599 61.5702Z",
    fill: "#9E9E9E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 78,
    r: 28,
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2842 85H54.8604V75.8418C54.8604 75.0801 54.8838 74.3594 54.9307 73.6797C54.8076 73.8027 54.6699 73.9316 54.5176 74.0664C54.3652 74.2012 53.668 74.7725 52.4258 75.7803L51.6523 74.7783L55.0537 72.1504H56.2842V85ZM65.1963 77.1514C66.5498 77.1514 67.6133 77.4883 68.3867 78.1621C69.166 78.8301 69.5557 79.7471 69.5557 80.9131C69.5557 82.2432 69.1309 83.2861 68.2812 84.042C67.4375 84.7979 66.2715 85.1758 64.7832 85.1758C63.3359 85.1758 62.2314 84.9443 61.4697 84.4814V83.0752C61.8799 83.3389 62.3896 83.5469 62.999 83.6992C63.6084 83.8457 64.209 83.9189 64.8008 83.9189C65.832 83.9189 66.6318 83.6758 67.2002 83.1895C67.7744 82.7031 68.0615 82 68.0615 81.0801C68.0615 79.2871 66.9629 78.3906 64.7656 78.3906C64.209 78.3906 63.4648 78.4756 62.5332 78.6455L61.7773 78.1621L62.2607 72.1504H68.6504V73.4951H63.5088L63.1836 77.3535C63.8574 77.2188 64.5283 77.1514 65.1963 77.1514Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.133 71.9658C144.305 71.9658 145.233 72.2383 145.919 72.7832C146.604 73.3281 146.947 74.0811 146.947 75.042C146.947 75.6748 146.751 76.252 146.358 76.7734C145.966 77.2949 145.339 77.7695 144.478 78.1973C145.521 78.6953 146.262 79.2197 146.701 79.7705C147.141 80.3154 147.36 80.9482 147.36 81.6689C147.36 82.7354 146.988 83.5879 146.244 84.2266C145.5 84.8594 144.48 85.1758 143.186 85.1758C141.814 85.1758 140.76 84.877 140.021 84.2793C139.283 83.6758 138.914 82.8232 138.914 81.7217C138.914 80.251 139.811 79.1055 141.604 78.2852C140.795 77.8281 140.215 77.3359 139.863 76.8086C139.512 76.2754 139.336 75.6807 139.336 75.0244C139.336 74.0928 139.679 73.3516 140.364 72.8008C141.056 72.2441 141.979 71.9658 143.133 71.9658ZM140.355 81.7568C140.355 82.46 140.599 83.0078 141.085 83.4004C141.577 83.793 142.266 83.9893 143.15 83.9893C144.023 83.9893 144.703 83.7842 145.189 83.374C145.676 82.9639 145.919 82.4014 145.919 81.6865C145.919 81.1182 145.69 80.6143 145.233 80.1748C144.776 79.7295 143.979 79.2988 142.843 78.8828C141.97 79.2578 141.337 79.6738 140.944 80.1309C140.552 80.582 140.355 81.124 140.355 81.7568ZM143.115 73.1523C142.383 73.1523 141.809 73.3281 141.393 73.6797C140.977 74.0312 140.769 74.5 140.769 75.0859C140.769 75.625 140.941 76.0879 141.287 76.4746C141.633 76.8613 142.271 77.248 143.203 77.6348C144.041 77.2832 144.633 76.9053 144.979 76.501C145.33 76.0967 145.506 75.625 145.506 75.0859C145.506 74.4941 145.292 74.0254 144.864 73.6797C144.442 73.3281 143.859 73.1523 143.115 73.1523Z",
    fill: "#C4C4C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206,
    height: 130,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkloadBreakdown);
export default __webpack_public_path__ + "static/media/WorkloadBreakdown.bd78df7d5e5adb481ea01ff6852b1824.svg";
export { ForwardRef as ReactComponent };